import React from "react";
import Grid from "@material-ui/core/Grid";
import InstagramIcon from "@material-ui/icons/Instagram";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import MailIcon from "@material-ui/icons/Mail";
// Custom components
import { AlignCenter, StyledLink, StyledDivider } from "../general";

// alignCenter is used in adminPage where we for instance dont want to wrap
// the footer in AlignCenter twice.
export default ({ alignCenter = true }) => {
  if (alignCenter) {
    return (
      <div>
        <StyledDivider />

        <AlignCenter>
          <FooterContent />
        </AlignCenter>
      </div>
    );
  } else {
    return <FooterContent />;
  }
};

const FooterContent = () => (
  <>
    <Grid container style={{ paddingTop: 24, paddingBottom: 20 }}>
      <Grid item style={{ marginRight: "5%" }}>
        <h3 style={{ marginBottom: 18 }}>Contact us</h3>
        <StyledLink href="mailto:hello@clmte.com">
          <FooterLink icon={<MailIcon />} text="hello@clmte.com" />
        </StyledLink>
        <StyledLink href="mailto:press@clmte.com">
          <FooterLink icon={<MailIcon />} text="press@clmte.com" />
        </StyledLink>
        <StyledLink href="mailto:ir@clmte.com">
          <FooterLink icon={<MailIcon />} text="ir@clmte.com" />
        </StyledLink>
        <StyledLink href="mailto:technicalsupport@clmte.com">
          <FooterLink icon={<MailIcon />} text="technicalsupport@clmte.com" />
        </StyledLink>
      </Grid>

      <Grid item style={{ marginRight: "5%" }}>
        <h3 style={{ marginBottom: 18 }}>Stay in touch</h3>
        <StyledLink href="https://www.instagram.com/clmte.sweden/?hl=sv">
          <FooterLink icon={<InstagramIcon />} text="Instagram" />
        </StyledLink>
        <StyledLink href="https://www.linkedin.com/company/42396949/">
          <FooterLink icon={<LinkedInIcon />} text="LinkedIn" />
        </StyledLink>
      </Grid>
    </Grid>

    <Grid
      container
      alignItems="center"
      style={{
        borderTop: "1px solid white",
        paddingTop: 12,
        opacity: 0.7,
        fontSize: 12,
      }}
    >
      <Grid item>
        <p>© CLMTE {new Date().getFullYear()}</p>
      </Grid>
    </Grid>
  </>
);

const FooterLink = ({ icon, text }) => (
  <div>
    <div style={{ display: "inline-block", verticalAlign: "middle" }}>
      {icon}
    </div>
    <div
      style={{
        marginLeft: 4,
        marginBottom: 4,
        display: "inline-block",
        verticalAlign: "middle",
      }}
    >
      {text}
    </div>
  </div>
);
